import { create } from 'zustand';
import { IEssayTheme } from '../../../core/models/essay';

interface EssayState {
  themeDetails: IEssayTheme | null;
  themes: [];
  setTheme: (theme: IEssayTheme) => void;
  setThemes: (theme: []) => void;
  resetEssay: () => void;
}

export const useEssayStore = create<EssayState>((set) => ({
  themeDetails: null,
  themes: [],
  setTheme: (theme: IEssayTheme) => set({ themeDetails: theme }),
  setThemes: (themes: []) => set({ themes: themes }),
  resetEssay: () => set({
    themeDetails: null,
    themes: []
  })
}));
